import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './core/authentication/authentication.service';
import { InactivityService } from './core/services/inactivity.service';
import { LoggedUserService } from './core/services/logged-user.service';
import { PaymentOverdueService } from './core/services/payment-overdue.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'innova-links-FE';
  user: boolean = false;

  constructor(
    readonly authService: AuthenticationService,
    readonly loggedUserService: LoggedUserService,
    private readonly paymentOverdueService: PaymentOverdueService,
    private readonly inactivityService: InactivityService,
  ) {
    this.user = this.loggedUserService.loggedUser;

    // A tab left on the login page when another tab signs in adopts that session
    // instead of reloading, so it needs the same start-up LoginComponent performs.
    this.authService.onSignedInElsewhere = () => {
      this.inactivityService.startInactivityService();
      this.paymentOverdueService.start(true);
    };
  }

  ngOnInit(): void {
    // The shell outlives navigation, so starting here covers every route on
    // reload. Sign in is handled by LoginComponent, whose shell is already up.
    this.paymentOverdueService.start();
  }
}
